import { globalModel } from "../../global/GlobalModel";
import { ShellTopBar } from "../shell/ShellTopBar";
import CustomerBenefitsPage from "../../customer_account/BenefitsPage";

export default function PlatformBenefitsPage(): JSX.Element {
  return (
    <CustomerBenefitsPage
      scope="platform"
      fixedTopBar
      topBar={<ShellTopBar onLoginClick={() => globalModel.openLoginModal()} />}
    />
  );
}
